var exports = {
  "Q": "celebrate__M1vozU",
  "K": "copilotRun__9vMEUx",
};

module.exports = exports;
